export type RuVectorSource = 'os' | 'kb';

export interface RuVectorSearchResult {
  id: string;
  title: string;
  path?: string;
  snippet?: string;
  modifiedMs?: number;
  similarity?: number;
  source: RuVectorSource;
}

export interface RuVectorStats {
  initialized: boolean;
  dimensions: number;
  baseDir?: string | null;
  os?: any;
  kb?: any;
  error?: string;
}

const UNAVAILABLE_MESSAGE = 'Local RuVector indexing is unavailable in the web-only CanXP AI build.';

export function isRuVectorAvailable(): boolean {
  return false;
}

export async function ruvectorStats(): Promise<RuVectorStats> {
  return {
    initialized: false,
    dimensions: 384,
    baseDir: null,
    error: UNAVAILABLE_MESSAGE,
  };
}

export async function ruvectorSearch(_params: {
  source: RuVectorSource;
  queryEmbedding: number[];
  limit?: number;
  filters?: any;
}): Promise<{ ok: boolean; results: RuVectorSearchResult[]; error?: string }> {
  return {
    ok: false,
    results: [],
    error: UNAVAILABLE_MESSAGE,
  };
}

export async function ruvectorClear(_source: RuVectorSource): Promise<{ ok: boolean; error?: string }> {
  return { ok: false, error: UNAVAILABLE_MESSAGE };
}

export async function ruvectorIndexStart(_scopes: string[]): Promise<{ ok: boolean; error?: string }> {
  return { ok: false, error: UNAVAILABLE_MESSAGE };
}

export async function ruvectorIndexStop(): Promise<{ ok: boolean; error?: string }> {
  return { ok: false, error: UNAVAILABLE_MESSAGE };
}

export async function ruvectorIndexStatus(): Promise<{ ok: boolean; status: any; error?: string }> {
  return { ok: false, status: null, error: UNAVAILABLE_MESSAGE };
}
